export default async function fetchPersonalByDependenciaUsecase(repository, idDependencia) {
  const personal = await repository.fetchPersonalByDependencia(idDependencia)

  const remapedPersonal = personal.map((item) => ({
    ...item,
    puesto: item.CatPuestoDependencia[0]?.catPuesto[0]?.puesto ?? 'N/A',
  }))

  return remapedPersonal
}
